import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RouteReportPage from 'views/donor/reports-section/report-route';
import DonorTaxDeductionReportPage from 'views/donor/reports-section/tax-deduction-report';

// sample page routing
const Dashboard = Loadable(lazy(() => import('views/donor/dashboard')));
const DonorMetrics = Loadable(lazy(() => import('views/donor/metrics/DonorMetrics')));
const DonorRoutineRoutesPage = Loadable(lazy(() => import('views/donor/routine-donations/DonorRoutineRoutesPage')));
const DonorOnDemandRoutesPage = Loadable(lazy(() => import('views/donor/on-demand-donations/DonorOnDemandRoutesPage')));
const CreateOnDemandRoutePage = Loadable(lazy(() => import('views/donor/on-demand-donations/CreateOnDemandRoutePage')));
const UpdateProfilePage = Loadable(lazy(() => import('views/donor/profile/DonorUpdateProfile')));

// ==============================|| MAIN ROUTING ||============================== //

const DonorRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Dashboard />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/metrics',
            element: <DonorMetrics key="metrics" />
        },
        {
            path: '/upcoming-routine-donations',
            element: <DonorRoutineRoutesPage upcoming={true} key="routine-upcoming" />,
        },
        {
            path: '/past-routine-donations',
            element: <DonorRoutineRoutesPage upcoming={false} key="routine-past" />,
        },
        {
            path: '/upcoming-on-demand-donations',
            element: <DonorOnDemandRoutesPage upcoming={true} key="on-demand-upcoming" />,
        },
        {
            path: '/past-on-demand-donations',
            element: <DonorOnDemandRoutesPage upcoming={false} key="on-demand-past" />,
        },
        {
            path: '/create-on-demand-donation',
            element: <CreateOnDemandRoutePage key="create" />,
        },
        {
            path: '/user/update-profile',
            element: <UpdateProfilePage />
        },
        {
            path: '/report/route',
            element: <RouteReportPage />
        },
        {
            path: '/report/tax-deduction',
            element: <DonorTaxDeductionReportPage />
        }
    ]
};

export default DonorRoutes;
